<template>
  <b-card title="Servis Bilgileri">
    <b-list-group>
      <list-item
        v-if="dataItem.customer_company"
        label-text="Firma Adı"
        :value-text="dataItem.customer_company"
      />
      <list-item
        v-if="dataItem.customer_name"
        label-text="İlgili Kişi"
        :value-text="dataItem.customer_name"
      />
      <list-item
        v-if="dataItem.service_type"
        label-text="Hizmet Şekli"
        is-badge
        :badge-variant="dataItem.service_type_variant"
        :value-text="dataItem.service_type"
      />
      <list-item
        v-if="dataItem.service_status"
        label-text="Durum"
        is-badge
        :badge-variant="dataItem.service_status_variant"
        :value-text="dataItem.service_status"
      />
      <list-item
        v-if="dataItem.sdate"
        label-text="Başlangıç"
        :value-text="dataItem.sdate"
        is-date
      />
      <list-item
        v-if="dataItem.edate"
        label-text="Teslim"
        :value-text="dataItem.edate"
        is-date
      />
      <list-item
        v-if="dataItem.username"
        label-text="Oluşturma"
        :value-text="dataItem.username"
      />
      <b-list-group-item v-if="dataItem.totalDurations">
        <div>
          <div class="text-primary font-weight-bold">
            Toplam Mesai Süresi
          </div>
          <div class="font-weight-bolder text-danger font-medium-2">
            {{ dataItem.totalDurations.formatted_duration }}
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>
<script>
import { BCard, BListGroup, BListGroupItem } from 'bootstrap-vue'
import ListItem from '@/views/Services/View/ListItem.vue'

export default {
  name: 'ServiceCard',
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    ListItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
}
</script>
